export function key(): string {
    return 'X-Sisu-Frontend-Info';
}

export function value(frontendName: string): string {
    // @ts-ignore
    return `${frontendName}/${BUILD_VERSION}`;
}
